import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '@core-argos-angular-artifact/core';

@Component({
  selector: 'my-account-application-landing',
  templateUrl: './application-landing.component.html',
  styleUrls: ['./application-landing.component.scss']
})
export class ApplicationLandingComponent implements OnInit {
  constructor(private readonly authService: AuthenticationService) {}

  userLogged = false;

  ngOnInit(): void {
    this.userLogged = this.authService.isAuthenticated();
  }

  login(): void {
    this.authService.login();
  }
}
